import { ReactNode } from 'react'
import HoverItem from '@/app/(site)/(static)/about/components/hover-images/hover-item'
import { IMAGE_PATH } from '../../config/constants'

type ValueEntry = {
    title: ReactNode
    description: ReactNode
    src: string
}

const VALUES: ValueEntry[] = [
    {
        title: 'People Before Product',
        description: (
            <p>
                The most important product we can ever develop is our{' '}
                <HoverItem hoverId="people" className="font-bold">
                    people
                </HoverItem>
                . People make products, people use products, we are a people company.
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/PeopleBeforeProduct.gif`,
    },
    {
        title: 'Community Before Corporation',
        description: (
            <p>
                We win and lose together. We all make it together or we don&apos;t make it at all. Clear{' '}
                <HoverItem hoverId="eyes" className="font-bold">
                    eyes
                </HoverItem>
                , full{' '}
                <HoverItem hoverId="hearts" className="font-bold">
                    hearts
                </HoverItem>
                ...
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/Community.gif`,
    },
    {
        title: 'Relationships Before Process',
        description: (
            <p>
                <HoverItem hoverId="relationships" className="font-bold">
                    Relationships
                </HoverItem>{' '}
                are the root of all processes. Our relationships will determine if our processes live or die.
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/Relationships.gif`,
    },
    {
        title: <span>It&apos;s not what we can&apos;t do, it&apos;s what we can do.</span>,
        description: (
            <p>
                Problems are easy.{' '}
                <HoverItem hoverId="solutions" className="font-bold">
                    Solutions
                </HoverItem>{' '}
                are hard. We like to solve problems and we choose to be GIPHYcans and not GIPHYcan&apos;ts.
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/CantDoCanDo.gif`,
    },
    {
        title: 'Post GIPHY',
        description: (
            <p>
                We are a{' '}
                <HoverItem hoverId="post" className="font-bold">
                    Post GIPHY
                </HoverItem>{' '}
                company. We are always looking for ways to improve ourselves, our products, and our community.
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/PostGIPHY.gif`,
    },
    {
        title: 'GIPHY for Good',
        description: (
            <p>
                GIPHY reaches hundreds of millions of people across the{' '}
                <HoverItem hoverId="good" className="font-bold">
                    world
                </HoverItem>{' '}
                every day. We have the opportunity to meaningfully change user behavior by exposing our users to new
                ideas, encouraging positivity, and actively fighting hate and injustice on the internet. We have a
                notable impact on the world, and we take this responsibility seriously!
            </p>
        ),
        src: `${IMAGE_PATH}/philosophies/GIPHYForGood.gif`,
    },
]

export default VALUES
